module.exports = {"web":{"client_id":"144749890226-o9dkp52vjflieam9un0vetghc8d2mtf1.apps.googleusercontent.com","project_id":"databox-513205","auth_uri":"https://accounts.google.com/o/oauth2/auth","token_uri":"https://oauth2.googleapis.com/token","auth_provider_x509_cert_url":"https://www.googleapis.com/oauth2/v1/certs","client_secret":"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","redirect_uris":["https://app.databox.work","http://localhost:8081"],"javascript_origins":["https://app.databox.work","http://localhost:8081"]}}


//////////////////
// WEBPACK FOOTER
// ./src/components/GoogleAuth/gp.json
// module id = j1kk
// module chunks = 1